import {
	AutocompleteInput,
	Create,
	ReferenceInput,
	SimpleForm,
	required,
} from "react-admin";
import { useCreateSubmit } from "../../forms";

export const OrganTeamCreate = () => {
	const submit = useCreateSubmit("organ-teams", "Team assigned to the organ", {
		resource: "organs",
		idColumn: "organ_id",
		view: "show",
	});

	return (
		<Create title="Assign team to organ">
			<SimpleForm onSubmit={submit}>
				<ReferenceInput source="organ_id" reference="organs">
					<AutocompleteInput
						validate={required()}
						optionText="name"
						fullWidth
						disabled
					/>
				</ReferenceInput>
				<ReferenceInput source="team_id" reference="teams">
					<AutocompleteInput
						validate={required()}
						optionText="name"
						fullWidth
					/>
				</ReferenceInput>
			</SimpleForm>
		</Create>
	);
};
